module.exports = __webpack_public_path__ + "img/loading.e46d3467.gif";